/**
 * Footer newsletter — the Aanmelden button is visually hidden (submit happens
 * with Enter), but another-mailchimp only wires its AJAX handler on a click of
 * .mpam-submit. Route Enter through a programmatic click on the hidden button.
 */
document.addEventListener('keydown', (e) => {
	if (e.key !== 'Enter') return;

	const input = e.target;
	if (!input.matches('.footer-newsletter input[type="email"], .footer-newsletter input[type="text"]')) return;

	e.preventDefault();

	const submit = input.closest('form')?.querySelector('.mpam-submit, input[type="submit"]');
	if (submit) submit.click();
});
